import '../../assets/css/bootstrap.min.css';
import 'react-mdl/extra/material.css';
import 'commonsComponents/main.scss';
import '../../styles/form/_form.scss';
import './app.scss';

import React, { useState, useEffect } from 'react';
import { history } from 'routes/history';
import { LoginModal } from 'components/commons/loginForm/LoginModal';
import { ContinueOnboarding } from 'components/continueOnboarding/ContinueOnboarding';
const { HelpTooltip } = require('components/tooltip/tooltip').HelpTooltip;
import { ModalCancel } from 'components/steps/modalCancel';
import { Header } from 'components/header/header';
import { PreLoader } from 'components/preLoader/preLoader';
import { ErrorsScreen } from 'components/errorsScreen/errorsScreen';
import Storage from 'utilities/storage';
import { CALL_ME_BACK } from 'constants/featureFlagging';
import { isDevtoolsAllowed } from 'utilities/devUtils';
import { PUBLICA_URL } from 'constants/index';
import { formatText } from 'core/i18n';
import BasicErrorModal from 'components/commons/basicErrorModal/basicErrorModal';

export const App = ({
    translationsActions,
    featureFlaggingActions,
    formActions,
    globalErrorModal,
    globalErrorModalActions,
    flags,
    children,
    location,
    translations,
}) => {
    const [undermaintenance, setUnderMaintenance] = useState(false);
    const [showLoginForm, setShowLoginForm] = useState(false);

    useEffect(() => {
        if (Storage.cookies.get('undermaintenance')) {
            setUnderMaintenance(true);
        }

        translationsActions.requestTranslations();
        featureFlaggingActions.requestFeatureFlagging();
        Storage.cookies.remove('TC_product');
    }, []);

    const handleReturnClick = event => {
        event.preventDefault();
        history.push(PUBLICA_URL);
    };

    const onClickAllowShowStrings = () => {
        if (typeof window.allowShowStrings === 'undefined') {
            window.allowShowStrings = true;
            formActions.change('userProfile.allowShowStrings', true);
        } else {
            window.allowShowStrings = !window.allowShowStrings;
            formActions.change('userProfile.allowShowStrings', window.allowShowStrings);
        }
    };

    const renderAllowShowStrings = () => {
        if (isDevtoolsAllowed()) {
            return (
                <div className="allow-show-strings">
                    <input type="checkbox" name="allowShowStrings" onClick={onClickAllowShowStrings} />
                    <span> Mostrar código de cadena</span>
                </div>
            );
        }
        return null;
    };

    const handleClickShowLogin = () => {
        setShowLoginForm(!showLoginForm);
    };

    const showLoginClientForm = () => {
        if (isDevtoolsAllowed()) {
            return (
                <div className="alow-login-form">
                    <button onClick={handleClickShowLogin}>Abrir login form</button>
                </div>
            );
        }
    };

    const renderApp = () => {
        const showModal = globalErrorModal.get('showModal');
        const callback = globalErrorModal.get('callback');
        const titleTextKey = globalErrorModal.get('info').get('titleTextKey');
        const infoTextKey = globalErrorModal.get('info').get('infoTextKey');
        const buttonTextKey = globalErrorModal.get('info').get('buttonTextKey');
        const info = {
            titleTextKey,
            infoTextKey,
            buttonTextKey,
        };
        return (
            <div id="content" className="global-content" data-version={__VERSION__}>
                {children}
                {flags.get(CALL_ME_BACK) && <HelpTooltip />}
                <ModalCancel />
                <ContinueOnboarding location={location} />
                <PreLoader />
                <BasicErrorModal
                    showModal={showModal}
                    callback={callback}
                    info={info}
                    closeModal={() => globalErrorModalActions.switchGlobalErrorModal(false)}
                />
                <div>
                    <LoginModal show={showLoginForm} onClose={handleClickShowLogin} />
                    {renderAllowShowStrings()}
                    {showLoginClientForm()}
                </div>
            </div>
        );
    };

    const renderMaintenance = () => {
        return (
            <div>
                <Header titleClass="hidden" />
                <div className="main-container errors-main-container">
                    <ErrorsScreen
                        iconClass="icons icons--icon-undermaintenance"
                        title={formatText('errors-undermaintenance')}
                        subtitle={formatText('errors-undermaintenanceMessage')}
                        buttonText={formatText('errors-buttonReturn')}
                        action={handleReturnClick}
                    />
                </div>
            </div>
        );
    };

    if (!translations.get('completed')) {
        return null;
    }

    return undermaintenance ? renderMaintenance() : renderApp();
};
